webpackJsonp([117735406666936],{

/***/ 597:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.SheShines = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(18);
	
	var _Heading = __webpack_require__(7);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _contentPage = __webpack_require__(4);
	
	var _contentPage2 = _interopRequireDefault(_contentPage);
	
	var _meta = __webpack_require__(5);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFacebookPixel = __webpack_require__(9);
	
	var _reactFacebookPixel2 = _interopRequireDefault(_reactFacebookPixel);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Modal = __webpack_require__(8);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _reactSlick = __webpack_require__(15);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	__webpack_require__(13);
	
	__webpack_require__(12);
	
	var _reactLinkedinInsight = __webpack_require__(16);
	
	var _reactLinkedinInsight2 = _interopRequireDefault(_reactLinkedinInsight);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var icon1 = "https://winpeforum.com/assets/elements/AishwaryaJaishankar.jpg";
	var icon2 = "https://winpeforum.com/assets/elements/NandikaPradeep.png";
	var icon3 = "https://winpeforum.com/assets/elements/SunithaViswanathan.jpg";
	var icon5 = "https://winpeforum.com/assets/elements/SaloniJhaveri.png";
	var icon6 = "https://winpeforum.com/assets/elements/ShivaniBhasin.png";
	var icon4 = "https://winpeforum.com/assets/elements/Lizzie.png";
	var duration = 400;
	
	var I1 = "https://www.winpeforum.com/assets/sheshines/11dec2025/1.png";
	var I2 = "https://www.winpeforum.com/assets/sheshines/11dec2025/2.png";
	var I3 = "https://www.winpeforum.com/assets/sheshines/11dec2025/3.png";
	var I4 = "https://www.winpeforum.com/assets/sheshines/11dec2025/4.png";
	var I5 = "https://www.winpeforum.com/assets/sheshines/11dec2025/5.png";
	var I6 = "https://www.winpeforum.com/assets/sheshines/11dec2025/6.png";
	var I7 = "https://www.winpeforum.com/assets/sheshines/11dec2025/7.png";
	var I8 = "https://www.winpeforum.com/assets/sheshines/11dec2025/8.png";
	
	var II1 = "https://www.winpeforum.com/download.php?file=assets/sheshines/11dec2025/1.png";
	var II2 = "https://www.winpeforum.com/download.php?file=assets/sheshines/11dec2025/2.png";
	var II3 = "https://www.winpeforum.com/download.php?file=assets/sheshines/11dec2025/3.png";
	var II4 = "https://www.winpeforum.com/download.php?file=assets/sheshines/11dec2025/4.png";
	var II5 = "https://www.winpeforum.com/download.php?file=assets/sheshines/11dec2025/5.png";
	var II6 = "https://www.winpeforum.com/download.php?file=assets/sheshines/11dec2025/6.png";
	var II7 = "https://www.winpeforum.com/download.php?file=assets/sheshines/11dec2025/7.png";
	var II8 = "https://www.winpeforum.com/download.php?file=assets/sheshines/11dec2025/8.png";
	
	var TeamModal = function TeamModal(_ref) {
	  var activeItem = _ref.activeItem,
	      show = _ref.show,
	      onHide = _ref.onHide;
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    {
	      direction: "",
	      className: "teamdetails__wrapper",
	      show: show,
	      onHide: onHide
	    },
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "head_section" },
	        _react2.default.createElement(
	          "span",
	          { className: "item_name" },
	          activeItem.name
	        ),
	        _react2.default.createElement("div", {
	          className: "item_des",
	          dangerouslySetInnerHTML: { __html: activeItem.post }
	        })
	      ),
	      _react2.default.createElement(
	        "span",
	        { className: "cross pull-right" },
	        _react2.default.createElement("i", { onClick: onHide, className: "fa fa-times" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "item__desc" },
	        _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: activeItem.desc } })
	      )
	    ),
	    _react2.default.createElement(_Modal2.default.Footer, null)
	  );
	};
	
	TeamModal.propTypes = {
	  activeItem: _propTypes2.default.object,
	  show: _propTypes2.default.object,
	  onHide: _propTypes2.default.object
	};
	
	var SheShines = exports.SheShines = function (_React$Component) {
	  _inherits(SheShines, _React$Component);
	
	  function SheShines(args) {
	    _classCallCheck(this, SheShines);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, args));
	
	    _this.updateWindowDimensions = function () {
	      var slidesToShow = _this.state.slidesToShow;
	      // // console.log("width", window.innerWidth)
	
	      if (window.innerWidth <= 768 && window.innerWidth > 500) {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      } else if (window.innerWidth <= 500) {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      } else {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      }
	    };
	
	    _this.togglePopUp = function (item) {
	      _this.setState({
	        isShow: !_this.state.isShow,
	        activeItem: item || {}
	      });
	    };
	
	    _this.state = {
	      slidesToShow: 1,
	      activeItem: {},
	      isShow: false,
	      defaultStyle: {
	        transition: "opacity " + duration + "ms ease-in-out",
	        opacity: 0
	      }
	    };
	
	    _this.Speaker1 = [{
	      imgUrl: icon1,
	      desc: "<div>\n        Aishwarya Jaishankar is the Co-founder and COO of Hyperface Technologies, Asia\u2019s first Credit Card-as-a-Service platform for cobrands.\n<br/><Br/>\n\nPassionate about reimagining banking and money management, Aishwarya is known for challenging the status quo and building products that deliver 10X\u2013100X impact. Her work spans pioneering Aadhaar OTP\u2013based customer onboarding, leading a global bank\u2019s digital overhaul, and now shaping next-generation credit card experiences at Hyperface.\n<br/><Br/>\n\n A career digital banker, she has driven multiple high-impact digital transformations for leading banks, including Kotak Mahindra Bank and HSBC India.\n<br/><br/>\n\nRecognised among the Top 60 LinkedIn Voices in India Fintech by Favikon, her contributions have earned accolades such as Finnoviti, MMA Smarties, and the Mastercard Innovation Award. She has also been featured in industry lists including Top Women in Fintech, AWS BuildHer, and was shortlisted for Fintech Woman of the Year by BFF.\n<br/><br/>\n\nAishwarya also serves on the Executive Committee of the India Fintech Forum, where she actively contributes to shaping the future of the fintech ecosystem. A career digital banker, she has driven multiple high-impact digital transformations for leading banks, including Kotak Mahindra Bank and HSBC India.\n\n\n          \n              </div>",
	      name: "Aishwarya Jaishankar",
	      post: "<div>Co- Founder & COO<br/>\n          Hyperface.co\n\n          </div>"
	    }, {
	      imgUrl: icon2,
	      desc: "<div>\n       Nandika has a deep passion for building organizations while keeping the founder\u2019s soul and vision at the center. Her expertise lies in translating organizational aspirations into execution realities by connecting people, strategy, and execution.  <br/><br/>\nIn her 15+ years of experience, Nandika has played various roles starting from being a consultant at Aon Hewitt, to leading multiple functional areas within HR globally at InMobi, to working alongside the founders driving business strategy, growth and operational excellence as part of InMobi's leadership team.<br/><br/>\nAt Fireside, she leads Strategy and People - She works on understanding where the consumer is headed, shaping the fund\u2019s long-term outlook, and strengthening the organization for scale. She partners closely with portfolio companies across multiple growth vectors, helping them navigate their next stage of evolution. In her role, she also meets with multiple founders ahead of investments, understanding their vision, leadership approach, and potential to scale.<br/><br/>\nNandika holds an MBA from ISB Hyderabad and a BA (Honours) in Economics from LSR, Delhi University.\n\n            </div>",
	      name: "Nandika Pradeep",
	      post: "<div>Director, Strategy & Human Capital<br/>Fireside Ventures\n \n     \n            </div>"
	    }, {
	      imgUrl: icon3,
	      desc: "<div>\n Sunitha Viswanathan is a Partner at Kae Capital. Prior to joining Kae Capital, she spent over 8 years with Unitus Ventures, a leading early-stage VC fund in Bangalore. At Unitus, she served on the boards of Cuemath, Masai School, Salesken, Awign, Blowhorn among others. Prior to Unitus Ventures, she worked with a technology startup in Bangalore. She has over a decade of experience spanning venture investment, banking and technology. Her experience also includes working with mid-market clients at Yes Bank. In addition to investing, Sunitha is also on the Board of Trustees of Mentor Together (India\u2019s largest mentoring organisation for underprivileged children).\n<Br/><br/>\nSunitha received her Bachelor\u2019s degree in Electronics and Communications Engineering from PES Institute of Technology, Bangalore and a Master\u2019s degree in Finance from S.P. Jain Institute of Management & Research, Mumbai. She has also cleared all 3 Levels of the program offered by the CFA Institute (USA).\n\n </div>",
	      name: "Sunitha Viswanathan",
	      post: "<div>Partner<br/> Kae Capital\n \n            </div>"
	    }];
	
	    _this.Speaker2 = [{
	      imgUrl: icon2,
	      desc: "Alka Goel is the Founder of Alkemi Growth Capital LLP, an early stage healthcare and consumer wellness fund. She has led investment in multiple sub-sectors over the last 6 years. Prior to that, Alka was a Partner in McKinsey & Co., New York office, where she primarily served clients in the life science and private equity industry.\n<br/><br/>\nAt McKinsey, she served more than 350 Clients across all major geographies. She completed her business school from Indian Institute of Management, Ahmedabad in 2000 and Bachelor of Economics from Lady Shri Ram College, Delhi University.\n\n\n         ",
	      name: "Alka Goel",
	      post: "<div>Founding Partner<br/> Alkemi Growth Capital\n        </div>"
	    }];
	    _this.CollegiumsImages = [{ id: 23, ImgSrc: I1, ImgSrc1: II1 }, { id: 35, ImgSrc: I2, ImgSrc1: II2 }, { id: 22, ImgSrc: I3, ImgSrc1: II3 }, { id: 19, ImgSrc: I4, ImgSrc1: II4 }, { id: 35, ImgSrc: I5, ImgSrc1: II5 }, { id: 34, ImgSrc: I6, ImgSrc1: II6 }, { id: 23, ImgSrc: I7, ImgSrc1: II7 }, { id: 35, ImgSrc: I8, ImgSrc1: II8 }];
	
	    return _this;
	  }
	
	  SheShines.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this.updateWindowDimensions();
	    window.addEventListener("resize", this.updateWindowDimensions);
	    _reactFacebookPixel2.default.init("2879175222167037");
	    _reactFacebookPixel2.default.track("ViewContent", location);
	    _reactLinkedinInsight2.default.init("2117884");
	    _reactLinkedinInsight2.default.track("2310748");
	    setTimeout(function () {
	      _this2.setState({
	        defaultStyle: {
	          transition: "opacity " + duration + "ms ease-in-out",
	          opacity: 1
	        }
	      });
	    }, 500);
	  };
	
	  SheShines.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener("resize", this.updateWindowDimensions);
	  };
	
	  SheShines.prototype.render = function render() {
	    var _this3 = this;
	
	    var _state = this.state,
	        defaultStyle = _state.defaultStyle,
	        isShow = _state.isShow,
	        slidesToShow = _state.slidesToShow;
	    var location = this.props.location;
	
	    var settings = {
	      dots: false,
	      infinite: true,
	      speed: 6000,
	      autoplay: true,
	      slidesToShow: slidesToShow,
	      slidesToScroll: slidesToShow,
	      autoplaySpeed: 7000,
	      arrows: true
	    };
	    console.log("render", this.render1, slidesToShow);
	    this.render1 = this.render1 + 1;
	    return _react2.default.createElement(
	      _contentPage2.default,
	      null,
	      _react2.default.createElement(_meta2.default, {
	        title: "sheshines with Winpe",
	        image: "https://winpeforum.com/assets/elements/sheshineswebpage1.png",
	        description: "Winpe's first in-person networking event for women in investing and entrepreneurship was welcomed with high enthusiasm and energy and demands for more such sessions! ",
	        location: location
	      }),
	      _react2.default.createElement(
	        "div",
	        { className: "section__content", style: defaultStyle },
	        _react2.default.createElement(
	          "div",
	          { className: "toastshine_wrapper" },
	          _react2.default.createElement(
	            "div",
	            { className: "back_event" },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/events/" },
	              _react2.default.createElement(
	                "i",
	                { className: "fa fa-arrow-left" },
	                "Back to Events"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "toastshine_section" },
	            _react2.default.createElement(
	              "div",
	              { className: "m_heading" },
	              "Winpe sheshines | December 11, 2025"
	            ),
	            _react2.default.createElement("div", { className: "r_btm" }),
	            _react2.default.createElement(
	              "div",
	              { className: "date_heading" },
	              _react2.default.createElement(
	                "div",
	                { className: "date_heading" },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  " sheshines Bangalore: \u201CFrom Idea to Impact: What Investors Look For \u2014 The said and the unsaid"
	                ),
	                " ",
	                _react2.default.createElement("br", null),
	                _react2.default.createElement("br", null),
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  "December 11, 2025 (5:00 - 8:00 PM IST)"
	                ),
	                _react2.default.createElement("br", null),
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  " ",
	                  _react2.default.createElement(
	                    "i",
	                    null,
	                    "Bangalore International Centre "
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "div",
	              { className: "top_text", style: { textAlign: 'justify' } },
	              "On 11 December 2025, sheshines arrived in Bangalore with an insightful and refreshingly candid conversation on what truly shapes investor decision-making. Hosted at the Library, Bangalore International Centre, the evening brought together founders, investors, and ecosystem leaders for a thoughtful exchange that went well beyond pitch decks and valuations\u2014diving into the realities, expectations, and unspoken signals that define the founder\u2013investor journey.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "Set against a backdrop of festive cheer, the space was alive with camaraderie and conversation. Christmas accessories, warm laughter, and glasses of mulled wine added to the atmosphere, creating an intimate, welcoming setting that encouraged openness and genuine connection. The holiday spirit infused the room, making it as much about community as it was about capital.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "h2",
	                { "class": "ignite-ask-me-anything__heading", style: { fontSize: "30px" } },
	                "Event Highlights"
	              ),
	              "          ",
	              _react2.default.createElement("div", { "class": "r_btm" }),
	              "The session created a safe and engaging space for honest dialogue between founders and investors. With perspectives from both sides of the table, the discussion unpacked not only what investors articulate publicly, but also the implicit cues, long-term commitments, and mindset shifts required to build venture-scale companies.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "The conversation was practical, reflective, and grounded in lived experience\u2014offering founders clarity on how to think about capital, partnerships, and the marathon that venture-building truly is. More than just a discussion, the evening felt like a shared moment of learning, connection, and celebration, perfectly in tune with the season.",
	              _react2.default.createElement("br", null),
	              " ",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "div",
	                { className: "row" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12" },
	                  _react2.default.createElement(
	                    "h2",
	                    { "class": "ignite-ask-me-anything__heading", style: { fontSize: "30px" } },
	                    "Speakers & Moderator"
	                  ),
	                  "          ",
	                  _react2.default.createElement("div", { "class": "r_btm" }),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "Our_Speakers container" },
	                    _react2.default.createElement(
	                      "center",
	                      null,
	                      _react2.default.createElement(
	                        "div",
	                        { className: "Speakers_img", style: { width: '100%', margin: '0' } },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          this.Speaker1.map(function (item, i) {
	                            if (i <= 10) {
	                              return _react2.default.createElement(
	                                "div",
	                                {
	                                  className: "main_speaker_card col-md-4 col-sm-12 col-lg-4",
	                                  key: i
	                                },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "Scardd" },
	                                  _react2.default.createElement(
	                                    "div",
	                                    {
	                                      className: "s_img",
	                                      onClick: function onClick() {
	                                        return _this3.togglePopUp(item);
	                                      }
	                                    },
	                                    _react2.default.createElement(
	                                      "center",
	                                      null,
	                                      "  ",
	                                      _react2.default.createElement("img", {
	                                        src: item.imgUrl,
	                                        alt: item.name,
	                                        className: "img-responsive",
	                                        style: { borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }
	                                      })
	                                    )
	                                  ),
	                                  _react2.default.createElement("br", null),
	                                  "    ",
	                                  _react2.default.createElement("div", {
	                                    className: "Speakers_name",
	                                    dangerouslySetInnerHTML: { __html: item.name }
	                                  }),
	                                  _react2.default.createElement("div", {
	                                    className: "Speakers_post",
	                                    dangerouslySetInnerHTML: { __html: item.post }
	                                  })
	                                )
	                              );
	                            } else return _react2.default.createElement(
	                              "div",
	                              {
	                                className: "main_speaker_card col-md-3 col-sm-12 col-lg-3",
	                                key: i
	                              },
	                              _react2.default.createElement(
	                                "div",
	                                { className: "Scardd" },
	                                _react2.default.createElement(
	                                  "div",
	                                  {
	                                    className: "s_img",
	                                    onClick: function onClick() {
	                                      return _this3.togglePopUp(item);
	                                    }
	                                  },
	                                  _react2.default.createElement(
	                                    "center",
	                                    null,
	                                    "  ",
	                                    _react2.default.createElement("img", {
	                                      src: item.imgUrl,
	                                      alt: item.name,
	                                      className: "img-responsive",
	                                      style: { borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }
	                                    })
	                                  )
	                                ),
	                                _react2.default.createElement("br", null),
	                                "    ",
	                                _react2.default.createElement("div", {
	                                  className: "Speakers_name",
	                                  dangerouslySetInnerHTML: { __html: item.name }
	                                }),
	                                _react2.default.createElement("div", {
	                                  className: "Speakers_post",
	                                  dangerouslySetInnerHTML: { __html: item.post }
	                                })
	                              )
	                            );
	                          })
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "h2",
	                { "class": "ignite-ask-me-anything__heading", style: { fontSize: "30px" } },
	                "Key Takeaways "
	              ),
	              _react2.default.createElement("div", { "class": "r_btm" }),
	              _react2.default.createElement(
	                "ul",
	                null,
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Founder Dynamics Are Critical"
	                  ),
	                  _react2.default.createElement("br", null),
	                  "Clear roles, responsibilities, and leadership alignment\u2014especially clarity on who the CEO is\u2014play a significant role in investor confidence."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Deep Problem Obsession Stands Out"
	                  ),
	                  _react2.default.createElement("br", null),
	                  "Investors back founders who show deep understanding of the problem and bring fresh, differentiated insights to the table."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Conviction, Ambition, and Self-Awareness Matter"
	                  ),
	                  _react2.default.createElement("br", null),
	                  "Strong founders combine clarity of vision and ambition with the humility to acknowledge gaps and solve for them."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Focus on Profitability and Fundamentals:"
	                  ),
	                  _react2.default.createElement("br", null),
	                  "Strong unit economics and a clear path to profitability, with emphasis on building enduring businesses grounded in fundamentals, rather than chasing market momentum."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Venture Capital Is a Long-Term Commitment"
	                  ),
	                  _react2.default.createElement("br", null),
	                  "Raising capital means committing to a 10\u201315 year journey, with sustained growth expectations year after year."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Purpose-Driven Investing:"
	                  ),
	                  _react2.default.createElement("br", null),
	                  "Embedding purpose\u2014through sustainability, community impact, and ethical governance\u2014has become a key differentiator, attracting talent, investors, and quality opportunities."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Decoding Investor Feedback"
	                  ),
	                  _react2.default.createElement("br", null),
	                  "\u201CIt\u2019s too early\u201D often reflects missing conviction, while \u201Csend updates\u201D signals interest\u2014though founders should share updates selectively."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Introductions Help, But Cold Outreach Still Works"
	                  ),
	                  _react2.default.createElement("br", null),
	                  "Warm references get priority, but well-crafted cold outreach is read and can open doors."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Choose Investors as Carefully as They Choose You"
	                  ),
	                  _react2.default.createElement("br", null),
	                  "Founder\u2013investor relationships typically last 7\u201310 years, making fit and alignment essential."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Gender Biases Remain Real"
	                  ),
	                  _react2.default.createElement("br", null),
	                  "Women founders, especially solo founders, continue to face systemic biases and must navigate them with awareness and strategy."
	                )
	              ),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "p",
	                null,
	                _react2.default.createElement(
	                  "i",
	                  null,
	                  "sheshines"
	                ),
	                " is part of Winpe Forum\u2019s ongoing commitment to creating inclusive spaces where women entrepreneurs and investors come together. Through these knowledge-sharing and networking forums, Winpe is dedicated to driving collaboration, learning, and growth within the PE-VC ecosystem\u2014empowering women to lead the future of investing and innovation."
	              )
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "div",
	              { className: "container" },
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(_Heading2.default, { title: "Gallery" })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "row" },
	                this.CollegiumsImages.map(function (item, j) {
	                  return _react2.default.createElement(
	                    "div",
	                    { className: "col-lg-4 col-md-4 col-sm-6 col-xs-12", style: { padding: '8px' } },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "img_card" },
	                      _react2.default.createElement("img", { style: { width: '100%' }, src: item.ImgSrc, alt: "Winpe sheshines" }),
	                      _react2.default.createElement(
	                        "a",
	                        { href: item.ImgSrc1 },
	                        " ",
	                        _react2.default.createElement("i", { style: { color: 'white', position: 'absolute', left: '20px', top: '20px' }, "class": "fa fa-2x  fa-download " })
	                      )
	                    )
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null)
	          ),
	          _react2.default.createElement(TeamModal, {
	            show: isShow,
	            onHide: this.togglePopUp,
	            activeItem: this.state.activeItem
	          })
	        )
	      )
	    );
	  };
	
	  return SheShines;
	}(_react2.default.Component);
	
	SheShines.propTypes = {
	  location: _propTypes2.default.object
	};
	
	exports.default = SheShines;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-sheshines-11-dec-2025-index-js-dc134edc4f2451f5036a.js